import { Grid, Typography } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';

const Enrich = () => {

    return (
        <Grid item xs={12} 
            sx={{backgroundColor: '#FFF', width:'100%', display:'flex', justifyContent:'center'}}>
            <Grid className='enrich-div' sx={{background: !isMobile && 'url(/assets/images/enrichbg.png) no-repeat', backgroundPosition:'bottom left', rowGap:'1em'}}>
                <Grid item xs={12} sm={5} md={5} lg={4} xl={4} sx={{mr: !isMobile && 2}}>
                    <Typography variant='h3' component={'h3'} className='titleStyle title-color'>
                            Enriching Lives and Spaces with Thoughtful MEP Solutions</Typography>
                    <Typography variant='bod2' component={'p'} className={'text-color'} 
                        sx={{fontFamily:'Inter',lineHeight:'1.8em', mt:1, overflowWrap:true, textOverflow:'ellipsis', overflow:'hidden'}}>
                       What turns a building into a safe, comfortable space? It is not just concrete and glass, it is the systems you do not see. At Unique Engineers, we work behind the scenes to make sure your space functions the way it should. Whether it is proper lighting, clean water, fresh air, or safe wiring, our Mechanical, Electrical, and Plumbing (MEP) solutions make everything come together.<br></br>
We do not just install equipment. We create environments where people can live, work, and breathe better. That is what makes us a reliable name among the <strong>top MEP consultants in Gurgaon.</strong>
                    </Typography>

                    <Typography variant='h3' component={'h3'} className='titleStyle title-color'>
                            Understanding the Purpose of Every Space</Typography>
                    <Typography variant='bod2' component={'p'} className={'text-color'} 
                        sx={{fontFamily:'Inter',lineHeight:'1.8em', mt:1, overflowWrap:true, textOverflow:'ellipsis', overflow:'hidden'}}>
                       Not every building is the same. A school does not need what a hotel needs. A factory runs very differently from an office. That is why we never offer one-size-fits-all plans.<br></br>
We begin by listening. What is your building used for? How many people will use it daily? What are your concerns - cost, sustainability, maintenance? We consider every factor.<br></br>
Then we build a tailored MEP design that works long-term. And because we think ahead, we help you save on costs, reduce energy waste, and stay future-ready.

                    </Typography>


                </Grid>
                <Grid item xs={12} sm={7} md={7} lg={6} xl={6} sx={{textAlign:'center'}}>
                    <img src={'/assets/images/iconsimage.jpg'} alt='iconsbg' className='enrich-img'/>
                    {/* <Grid xs={12}>
                        <Grid sx={{background:'url(/assets/images/subtract.png) no-repeat', width:318, height:72, display:'flex', alignItems:'center', pl:8}}>
                            <img src={'assets/images/healthcare-icon.png'} alt='healthcare' />
                            <Typography class={'normal-text size-20'} sx={{}} >Healthcare</Typography>
                        </Grid>
                        <Grid sx={{background:'url(/assets/images/subtract.png) no-repeat', width:318, height:72, display:'flex', alignItems:'center', pl:8}}>
                            <img src={'assets/images/malls-icon.png'} alt='healthcare' />
                            <Typography class={'normal-text size-20'} sx={{}} >Malls & multiplexes</Typography>
                        </Grid>
                        <Grid sx={{background:'url(/assets/images/subtract.png) no-repeat', width:318, height:72, display:'flex', alignItems:'center', pl:8}}>
                            <img src={'assets/images/industry-icon.png'} alt='healthcare' />
                            <Typography class={'normal-text size-20'} sx={{}} >Industries</Typography>
                        </Grid>
                        <Grid sx={{background:'url(/assets/images/subtract.png) no-repeat', width:318, height:72, display:'flex', alignItems:'center', pl:8}}>
                            <img src={'assets/images/hotels-icon.png'} alt='healthcare' />
                            <Typography class={'normal-text size-20'} sx={{}} >Hotel</Typography>
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
        </Grid>
    )


}

export default Enrich;